{
  "level": "in02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:in02",
    "objects": "AREAS.E3:in02.e3",
    "mesh": "TREES.E3:in02.e3"
  },
  "spawn_point": {
    "position": [
      -3943.459625446244,
      -3317.54877962024,
      928.52001953125
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3943.459625446244,
      -3217.54877962024,
      928.52001953125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4461.83984375,
      -5175.2490234375,
      904.52001953125
    ],
    "bbox_max": [
      -3786.0,
      -3072.300048828125,
      1079.767333984375
    ],
    "vertex_count": 302,
    "vertices": [
      [
        -3855.5009765625,
        -3105.7685546875,
        1031.1925048828125
      ],
      [
        -3844.50048828125,
        -3105.7685546875,
        1031.1927490234375
      ],
      [
        -3844.50048828125,
        -3105.7685546875,
        1023.5548095703125
      ],
      [
        -3855.5009765625,
        -3105.7685546875,
        1023.5550537109375
      ],
      [
        -3863.00048828125,
        -3072.300048828125,
        1031.619873046875
      ],
      [
        -3863.00048828125,
        -3084.7685546875,
        1031.619873046875
      ],
      [
        -3861.14404296875,
        -3089.00048828125,
        1033.8558349609375
      ],
      [
        -3893.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3867.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3852.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3826.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3812.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3786.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3826.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3826.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3786.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3786.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3867.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3867.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3922.50048828125,
        -3129.7841796875,
        1012.5
      ],
      [
        -3922.50048828125,
        -3129.7841796875,
        1012.5
      ],
      [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      [
        -3925.0,
        -3184.800048828125,
        1005.2000122070312
      ],
      [
        -3861.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3861.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3821.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3901.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3901.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3826.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3786.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3867.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3861.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      [
        -3880.00048828125,
        -3154.2685546875,
        1029.464111328125
      ],
      [
        -3880.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3874.139404296875,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3805.861572265625,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3800.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3885.861572265625,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3880.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3920.00048828125,
        -3164.10009765625,
        1005.2000122070312
      ],
      [
        -3922.50048828125,
        -3164.10009765625,
        1012.5
      ],
      [
        -3922.50048828125,
        -3164.10009765625,
        1012.5
      ],
      [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3164.10009765625,
        1036.786865234375
      ],
      [
        -3920.000244140625,
        -3145.371337890625,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3922.50048828125,
        -3181.77001953125,
        1012.5
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      [
        -3922.50048828125,
        -3181.77001953125,
        1012.5
      ],
      [
        -3920.00048828125,
        -3167.7685546875,
        1061.22021484375
      ],
      [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1076.49462890625
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1079.767333984375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1005.28662109375
      ],
      [
        -3925.0,
        -3184.77001953125,
        1005.28662109375
      ],
      [
        -3925.0,
        -3182.2685546875,
        1012.5
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1005.2000122070312
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1005.28662109375
      ],
      [
        -3922.00830078125,
        -3181.77001953125,
        1013.9375
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3925.0,
        -3182.2685546875,
        1012.5
      ],
      [
        -3925.0,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      [
        -3925.0,
        -3224.7685546875,
        1019.7999877929688
      ],
      [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      [
        -3925.0,
        -3184.800048828125,
        1005.2000122070312
      ],
      [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      [
        -3940.00048828125,
        -3224.76806640625,
        1019.7999877929688
      ],
      [
        -3940.00048828125,
        -3224.76806640625,
        1012.5
      ],
      [
        -3940.00048828125,
        -3224.76806640625,
        1012.5
      ],
      [
        -3940.00048828125,
        -3224.76806640625,
        1005.2000122070312
      ],
      [
        -3899.980712890625,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3899.980712890625,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1019.735107421875
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1019.735107421875
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1019.735107421875
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1012.5
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1019.735107421875
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1012.5
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3920.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      [
        -3899.97802734375,
        -3264.60009765625,
        1019.7349243164062
      ],
      [
        -3919.978271484375,
        -3264.60009765625,
        1019.7349243164062
      ],
      [
        -3920.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      [
        -3919.978271484375,
        -3264.60009765625,
        1019.7349243164062
      ],
      [
        -3918.912841796875,
        -3244.7685546875,
        1016.623779296875
      ],
      [
        -3918.912841796875,
        -3224.7685546875,
        1016.623779296875
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3899.97802734375,
        -3264.60009765625,
        1019.7349243164062
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3920.00048828125,
        -3225.60009765625,
        1005.2000122070312
      ],
      [
        -3917.50048828125,
        -3225.60009765625,
        1012.5
      ],
      [
        -3917.50048828125,
        -3225.60009765625,
        1012.5
      ],
      [
        -3918.912841796875,
        -3225.60009765625,
        1016.623779296875
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1016.5999755859375
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1016.5999755859375
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3880.0,
        -3301.60595703125,
        1025.992919921875
      ],
      [
        -4002.39990234375,
        -3301.60595703125,
        1025.992919921875
      ],
      [
        -3898.89990234375,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3898.89990234375,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1011.6766967773438
      ],
      [
        -3980.00048828125,
        -3266.137451171875,
        1012.5
      ],
      [
        -3980.00048828125,
        -3266.137451171875,
        1012.5
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1011.6766357421875
      ],
      [
        -3898.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3273.793212890625,
        1016.5999755859375
      ],
      [
        -3898.89990234375,
        -3265.2001953125,
        1011.9981079101562
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1011.6766967773438
      ],
      [
        -3898.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.9979248046875
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1011.9981079101562
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1011.6766967773438
      ],
      [
        -3898.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.9979248046875
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1011.9981079101562
      ],
      [
        -3880.00048828125,
        -3278.991943359375,
        1017.21337890625
      ],
      [
        -3899.104248046875,
        -3278.991943359375,
        1017.21337890625
      ],
      [
        -4002.39990234375,
        -3278.989501953125,
        1017.21240234375
      ],
      [
        -3980.00048828125,
        -3278.989501953125,
        1017.21240234375
      ],
      [
        -3898.89990234375,
        -3277.47314453125,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3277.47314453125,
        1016.623779296875
      ],
      [
        -3899.104248046875,
        -3278.991943359375,
        1017.21337890625
      ],
      [
        -3898.89990234375,
        -3277.47314453125,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3278.989501953125,
        1017.21240234375
      ],
      [
        -3980.00048828125,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3277.473388671875,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3277.47314453125,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1011.6260375976562
      ],
      [
        -3980.00048828125,
        -3266.851318359375,
        1012.5
      ],
      [
        -3980.00048828125,
        -3266.851318359375,
        1012.5
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1011.6259765625
      ],
      [
        -3882.60009765625,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3894.0,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3880.0,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3882.60009765625,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3896.89990234375,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3894.0,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3898.89990234375,
        -3276.800048828125,
        1016.5999755859375
      ],
      [
        -3898.89990234375,
        -3277.411865234375,
        1016.5999755859375
      ],
      [
        -3898.89990234375,
        -3276.800048828125,
        1016.3624267578125
      ],
      [
        -3898.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1015.7412719726562
      ],
      [
        -3898.89990234375,
        -3265.2001953125,
        1011.8590087890625
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1011.6260375976562
      ],
      [
        -3898.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.85888671875
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1015.7412719726562
      ],
      [
        -3898.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3896.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.85888671875
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1011.8589477539062
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1011.8590087890625
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1011.6260375976562
      ],
      [
        -4002.39990234375,
        -3301.60595703125,
        1025.992919921875
      ],
      [
        -4002.39990234375,
        -3278.989501953125,
        1017.21240234375
      ],
      [
        -3880.00048828125,
        -3278.991943359375,
        1017.21337890625
      ],
      [
        -3880.0,
        -3301.60595703125,
        1025.992919921875
      ],
      [
        -3898.89990234375,
        -3264.619873046875,
        1005.2000122070312
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1005.2658081054688
      ],
      [
        -3896.89990234375,
        -3264.619873046875,
        1005.2000122070312
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1005.2658081054688
      ],
      [
        -3880.00048828125,
        -3264.619873046875,
        1005.2000122070312
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1005.2658081054688
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1005.3519287109375
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1005.3518676757812
      ],
      [
        -3882.60009765625,
        -3278.800048828125,
        1005.2097778320312
      ],
      [
        -3880.0,
        -3278.800048828125,
        1005.2097778320312
      ],
      [
        -3882.60009765625,
        -3278.800048828125,
        1005.2097778320312
      ],
      [
        -3894.0,
        -3278.800048828125,
        1005.2097778320312
      ],
      [
        -3898.89990234375,
        -3278.800048828125,
        1005.2097778320312
      ],
      [
        -3894.0,
        -3278.800048828125,
        1005.2097778320312
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1005.3458862304688
      ],
      [
        -3896.89990234375,
        -3275.2001953125,
        1005.2457885742188
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1005.3458862304688
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1005.3518676757812
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1005.2457885742188
      ],
      [
        -3898.89990234375,
        -3265.2001953125,
        1005.3458862304688
      ],
      [
        -3898.89990234375,
        -3265.2001953125,
        1005.3458862304688
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1005.3518676757812
      ],
      [
        -3898.89990234375,
        -3278.800048828125,
        1005.2097778320312
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1005.2457885742188
      ],
      [
        -3880.0,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3882.60009765625,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3896.89990234375,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3894.0,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3894.0,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3882.60009765625,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -4002.39990234375,
        -3297.07763671875,
        1011.001708984375
      ],
      [
        -4002.39990234375,
        -3292.055419921875,
        1022.2850341796875
      ],
      [
        -4002.39990234375,
        -3297.07763671875,
        1011.001708984375
      ],
      [
        -3880.0,
        -3297.081298828125,
        1010.9937133789062
      ],
      [
        -3880.0,
        -3297.081298828125,
        1010.9937133789062
      ],
      [
        -3880.000244140625,
        -3292.05517578125,
        1022.2850341796875
      ],
      [
        -4002.39990234375,
        -3278.812255859375,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3278.812255859375,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3278.812255859375,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3277.473388671875,
        1016.623779296875
      ],
      [
        -4002.39990234375,
        -3296.991943359375,
        1011.1943359375
      ],
      [
        -3880.0,
        -3296.991943359375,
        1011.1947021484375
      ],
      [
        -4022.39990234375,
        -3297.10009765625,
        1011.0
      ],
      [
        -4002.39990234375,
        -3297.08935546875,
        1010.9752807617188
      ],
      [
        -3880.0,
        -3297.08935546875,
        1010.9757080078125
      ],
      [
        -4022.39990234375,
        -3297.10009765625,
        1011.0
      ],
      [
        -4027.347412109375,
        -3339.394775390625,
        1026.53369140625
      ],
      [
        -4022.39990234375,
        -3338.5126953125,
        1026.51416015625
      ],
      [
        -4027.347412109375,
        -3339.394775390625,
        1026.53369140625
      ],
      [
        -4022.39990234375,
        -3345.09814453125,
        1011.46142578125
      ],
      [
        -4351.76171875,
        -3491.62255859375,
        1027.0509033203125
      ],
      [
        -4351.71923828125,
        -3491.641357421875,
        994.845703125
      ],
      [
        -4195.8359375,
        -3369.978271484375,
        1026.861328125
      ],
      [
        -4195.80322265625,
        -3370.03076171875,
        995.2791748046875
      ],
      [
        -4347.9072265625,
        -3664.7685546875,
        1026.864990234375
      ],
      [
        -4347.68994140625,
        -3663.48583984375,
        1026.8665771484375
      ],
      [
        -4347.68994140625,
        -3663.48583984375,
        1026.8665771484375
      ],
      [
        -4347.84765625,
        -3664.7685546875,
        995.2698974609375
      ],
      [
        -4347.41552734375,
        -3662.2080078125,
        995.262939453125
      ],
      [
        -4347.41455078125,
        -3662.203125,
        995.263427734375
      ],
      [
        -4341.03076171875,
        -3664.7685546875,
        1010.8619384765625
      ],
      [
        -4411.8330078125,
        -5031.62060546875,
        945.2203369140625
      ],
      [
        -4411.8330078125,
        -5031.62060546875,
        945.2203369140625
      ],
      [
        -4410.73193359375,
        -5035.68115234375,
        944.7672119140625
      ],
      [
        -4461.302734375,
        -4846.80712890625,
        996.8483276367188
      ],
      [
        -4461.83984375,
        -4844.7685546875,
        997.0745849609375
      ],
      [
        -4461.302734375,
        -4846.80712890625,
        996.8483276367188
      ],
      [
        -4441.07177734375,
        -4855.658203125,
        1001.9581298828125
      ],
      [
        -4443.82861328125,
        -4844.7685546875,
        1003.150146484375
      ],
      [
        -4441.07177734375,
        -4855.658203125,
        1001.9581298828125
      ],
      [
        -4400.10400390625,
        -5029.544921875,
        934.9754028320312
      ],
      [
        -4270.9365234375,
        -5175.2490234375,
        904.52001953125
      ],
      [
        -4407.65380859375,
        -5038.619140625,
        976.2511596679688
      ],
      [
        -4410.61376953125,
        -5035.61279296875,
        977.1580810546875
      ],
      [
        -4407.65380859375,
        -5038.619140625,
        976.2511596679688
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3780.0,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        978.0
      ],
      "bbox_max": [
        -3757.5,
        -3040.0,
        1128.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9460787773132324,
        0.0,
        0.3239368498325348
      ],
      "plane_d": -3882.87744140625,
      "bbox_min": [
        -3780.0,
        -3159.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3757.5,
        -3069.800048828125,
        1039.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460587501525879,
        5.281247013044776e-06,
        -0.32399508357048035
      ],
      "plane_d": -3226.75439453125,
      "bbox_min": [
        -3780.0,
        -3159.7685546875,
        1012.5
      ],
      "bbox_max": [
        -3757.5,
        -3069.800048828125,
        1039.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3760.0,
      "bbox_min": [
        -3760.0,
        -3147.7783203125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1039.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3780.0,
        -3147.7783203125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3776.400390625,
        -3089.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3224.76806640625,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        994.0
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1128.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.947304904460907,
        0.3203330934047699
      ],
      "plane_d": -3286.84375,
      "bbox_min": [
        -3925.00048828125,
        -3129.805908203125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1099.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3072.300048828125,
      "bbox_min": [
        -3925.00048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1099.786865234375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.2734627425670624,
        0.0,
        0.9618827104568481
      ],
      "plane_d": -2051.865966796875,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3865.21728515625,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.8320502638816833,
        0.0
      ],
      "plane_d": -4722.802734375,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.8320502638816833,
        0.0
      ],
      "plane_d": -451.6103515625,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3105.7685546875,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.595947265625,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24497897922992706,
        -0.4443757236003876,
        0.8616933226585388
      ],
      "plane_d": -1322.602294921875,
      "bbox_min": [
        -3865.21728515625,
        -3100.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.595947265625,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3863.000244140625,
      "bbox_min": [
        -3865.21728515625,
        -3100.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3089.7685546875,
      "bbox_min": [
        -3863.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7693594694137573,
        0.0,
        0.638816237449646
      ],
      "plane_d": -3631.051513671875,
      "bbox_min": [
        -3863.00048828125,
        -3089.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6246950626373291,
        0.7808687686920166
      ],
      "plane_d": -2738.068603515625,
      "bbox_min": [
        -3861.14404296875,
        -3089.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3084.7685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24497897922992706,
        -0.4443757236003876,
        0.8616933226585388
      ],
      "plane_d": -3208.940673828125,
      "bbox_min": [
        -3861.14404296875,
        -3089.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3084.7685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3086.768310546875,
      "bbox_min": [
        -3860.00048828125,
        -3086.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3855.00048828125,
        -3086.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16160258650779724,
        -0.383549302816391,
        0.9092714190483093
      ],
      "plane_d": -2748.810546875,
      "bbox_min": [
        -3861.14404296875,
        -3089.7685546875,
        1033.8558349609375
      ],
      "bbox_max": [
        -3855.00048828125,
        -3084.7685546875,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16160258650779724,
        -0.383549302816391,
        0.9092714190483093
      ],
      "plane_d": -2748.810546875,
      "bbox_min": [
        -3863.00048828125,
        -3089.00048828125,
        1033.623779296875
      ],
      "bbox_max": [
        -3859.405029296875,
        -3084.7685546875,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.623779296875,
      "bbox_min": [
        -3863.00048828125,
        -3099.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -3860.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8746603727340698,
        -0.4847361147403717,
        0.0
      ],
      "plane_d": -4876.05126953125,
      "bbox_min": [
        -3865.21728515625,
        -3088.7685546875,
        1020.2975463867188
      ],
      "bbox_max": [
        -3863.00048828125,
        -3072.300048828125,
        1033.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7693594694137573,
        0.0,
        0.638816237449646
      ],
      "plane_d": -3631.051513671875,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1028.9500732421875
      ],
      "bbox_max": [
        -3863.00048828125,
        -3072.300048828125,
        1031.619873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3105.7685546875,
      "bbox_min": [
        -3844.50048828125,
        -3105.7685546875,
        1023.5548095703125
      ],
      "bbox_max": [
        -3843.00048828125,
        -3105.7685546875,
        1031.1927490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3860.00048828125,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3855.5009765625,
        -3102.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3105.7685546875,
      "bbox_min": [
        -3857.00048828125,
        -3105.7685546875,
        1023.5550537109375
      ],
      "bbox_max": [
        -3855.5009765625,
        -3105.7685546875,
        1031.1925048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": -2630.56787109375,
      "bbox_min": [
        -3922.50048828125,
        -3129.805908203125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1022.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7375450134277344,
        -0.6752980351448059
      ],
      "plane_d": -1617.855712890625,
      "bbox_min": [
        -3893.500244140625,
        -3129.805908203125,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.314453125,
        1022.5366821289062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3826.0,
      "bbox_min": [
        -3867.0,
        -3129.805908203125,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.314453125,
        1022.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3786.0,
      "bbox_min": [
        -3786.0,
        -3129.805908203125,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.314453125,
        1022.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3867.0,
      "bbox_min": [
        -3867.0,
        -3129.805908203125,
        1022.0
      ],
      "bbox_max": [
        -3867.0,
        -3129.314453125,
        1022.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3129.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.0,
        -3127.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3382.87451171875,
      "bbox_min": [
        -3922.50048828125,
        -3129.7841796875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3127.300048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3925.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3129.7685546875,
        1079.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.737154483795166,
        -0.6757242679595947
      ],
      "plane_d": -1618.042724609375,
      "bbox_min": [
        -3925.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3129.7685546875,
        1079.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7367177605628967,
        -0.6762003898620605
      ],
      "plane_d": -1616.152099609375,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7375450134277344,
        -0.6752980351448059
      ],
      "plane_d": -1617.855712890625,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1079.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1035.0,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1079.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1079.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.076904296875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3184.7685546875,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      "bbox_max": [
        -3858.50048828125,
        -3184.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.076904296875,
        1079.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.076904296875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.7685546875,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3826.0,
      "bbox_min": [
        -3867.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3786.0,
      "bbox_min": [
        -3786.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3867.0,
      "bbox_min": [
        -3867.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3867.0,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.738097071647644,
        -0.6746945977210999
      ],
      "plane_d": -1622.046875,
      "bbox_min": [
        -3901.50048828125,
        -3148.121337890625,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3131.767822265625,
        1039.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3826.0,
      "bbox_min": [
        -3867.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3786.0,
      "bbox_min": [
        -3786.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3867.0,
      "bbox_min": [
        -3867.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3867.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3148.121337890625,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3148.121337890625,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3148.121337890625,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.33984375,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.77001953125,
      "bbox_min": [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.00048828125,
        -3129.7685546875,
        1079.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1036.786865234375,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.00048828125,
        -3129.7685546875,
        1076.49462890625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1007.623779296875,
      "bbox_min": [
        -3891.5,
        -3164.10009765625,
        1005.2037963867188
      ],
      "bbox_max": [
        -3790.0,
        -3144.0,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238727688789368,
        -0.3826998770236969,
        0.0
      ],
      "plane_d": 2370.5595703125,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3805.3037109375,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -2384.417724609375,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3874.697265625,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        -0.9238727688789368,
        0.0
      ],
      "plane_d": -1436.196044921875,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3874.697265625,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        -0.9238727688789368,
        0.0
      ],
      "plane_d": -4405.947265625,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        0.0
      ],
      "plane_d": -4798.6943359375,
      "bbox_min": [
        -3887.50048828125,
        -3159.57177734375,
        1005.2037963867188
      ],
      "bbox_max": [
        -3885.3037109375,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -2310.5078125,
      "bbox_min": [
        -3807.50048828125,
        -3159.57177734375,
        1005.2037963867188
      ],
      "bbox_max": [
        -3805.3037109375,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        -0.0
      ],
      "plane_d": -4724.7841796875,
      "bbox_min": [
        -3807.50048828125,
        -3159.57177734375,
        1005.2037963867188
      ],
      "bbox_max": [
        -3805.3037109375,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3154.2685546875,
      "bbox_min": [
        -3889.86376953125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3880.0,
      "bbox_min": [
        -3889.86376953125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082394242286682,
        -0.4082581102848053,
        0.8164960145950317
      ],
      "plane_d": -3669.82080078125,
      "bbox_min": [
        -3800.00048828125,
        -3154.2685546875,
        1017.4635620117188
      ],
      "bbox_max": [
        -3790.13720703125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082273244857788,
        -0.40826764702796936,
        0.8164974451065063
      ],
      "plane_d": -3674.68798828125,
      "bbox_min": [
        -3800.00048828125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3792.10986328125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        -0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": -3678.547607421875,
      "bbox_min": [
        -3800.00048828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3793.68798828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082394242286682,
        0.4082581102848053,
        -0.8164960145950317
      ],
      "plane_d": 567.20068359375,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1017.4635620117188
      ],
      "bbox_max": [
        -3800.00048828125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40825092792510986,
        0.40825092792510986,
        -0.8164939880371094
      ],
      "plane_d": 572.01416015625,
      "bbox_min": [
        -3807.89111328125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3800.00048828125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 576.009033203125,
      "bbox_min": [
        -3806.31298828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3800.00048828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082394242286682,
        -0.4082581102848053,
        0.8164960145950317
      ],
      "plane_d": -3702.47998046875,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1017.4635620117188
      ],
      "bbox_max": [
        -3870.13720703125,
        -3144.4052734375,
        1025.3099365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082581400871277,
        -0.408239483833313,
        0.8164960741996765
      ],
      "plane_d": -534.410400390625,
      "bbox_min": [
        -3889.86376953125,
        -3154.2685546875,
        1017.4635620117188
      ],
      "bbox_max": [
        -3880.00048828125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40825092792510986,
        -0.40825092792510986,
        0.8164939880371094
      ],
      "plane_d": -539.3541259765625,
      "bbox_min": [
        -3887.89111328125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 543.350830078125,
      "bbox_min": [
        -3886.31298828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3880.00048828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3880.0,
      "bbox_min": [
        -3889.86376953125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082394242286682,
        -0.4082581102848053,
        -0.8164960145950317
      ],
      "plane_d": 1126.96826171875,
      "bbox_min": [
        -3880.00048828125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082252085208893,
        -0.4082781672477722,
        -0.8164931535720825
      ],
      "plane_d": 1131.72900390625,
      "bbox_min": [
        -3880.00048828125,
        -3162.158935546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3872.10986328125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40822869539260864,
        -0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 1135.8109130859375,
      "bbox_min": [
        -3880.00048828125,
        -3160.5810546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3873.68798828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        -0.4082679748535156,
        -0.8164846897125244
      ],
      "plane_d": -2008.4029541015625,
      "bbox_min": [
        -3880.00048828125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1029.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40826407074928284,
        -0.40824514627456665,
        -0.8164902925491333
      ],
      "plane_d": -2003.487548828125,
      "bbox_min": [
        -3807.89111328125,
        -3162.158935546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1029.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6091537475585938,
        -0.6092593669891357,
        0.50767582654953
      ],
      "plane_d": -70.655517578125,
      "bbox_min": [
        -3880.00048828125,
        -3155.677490234375,
        1007.623779296875
      ],
      "bbox_max": [
        -3878.59130859375,
        -3154.2685546875,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        -0.4082679748535156,
        -0.8164846897125244
      ],
      "plane_d": -2041.0631103515625,
      "bbox_min": [
        -3889.86376953125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40826407074928284,
        -0.40824514627456665,
        -0.8164902925491333
      ],
      "plane_d": -2036.148681640625,
      "bbox_min": [
        -3887.89111328125,
        -3162.158935546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082396328449249,
        -0.40822869539260864,
        -0.816510796546936
      ],
      "plane_d": -2032.0521240234375,
      "bbox_min": [
        -3886.31298828125,
        -3160.5810546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6091538071632385,
        -0.6092593669891357,
        0.5076757669448853
      ],
      "plane_d": -4797.689453125,
      "bbox_min": [
        -3881.40966796875,
        -3155.677490234375,
        1007.623779296875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3382.87451171875,
      "bbox_min": [
        -3922.50048828125,
        -3164.10009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.0,
        -3129.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3164.10009765625,
        1012.5
      ],
      "bbox_max": [
        -3920.0,
        -3129.7841796875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3164.10009765625,
        1019.7999877929688
      ],
      "bbox_max": [
        -3920.0,
        -3129.800048828125,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3800.00048828125,
        -3164.10009765625,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3382.87451171875,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3164.10009765625,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082394242286682,
        -0.4082581102848053,
        -0.8164960145950317
      ],
      "plane_d": 1126.96826171875,
      "bbox_min": [
        -3885.861572265625,
        -3164.1318359375,
        1022.3794555664062
      ],
      "bbox_max": [
        -3800.00048828125,
        -3164.10009765625,
        1025.3099365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        -0.4082679748535156,
        -0.8164846897125244
      ],
      "plane_d": -2041.0631103515625,
      "bbox_min": [
        -3885.861572265625,
        -3164.1318359375,
        1022.3794555664062
      ],
      "bbox_max": [
        -3880.00048828125,
        -3164.10009765625,
        1025.3099365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        -0.4082679748535156,
        -0.8164846897125244
      ],
      "plane_d": -2008.4029541015625,
      "bbox_min": [
        -3805.861572265625,
        -3164.1318359375,
        1022.3794555664062
      ],
      "bbox_max": [
        -3800.00048828125,
        -3164.10009765625,
        1025.3099365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3167.7685546875,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3145.371337890625,
        1076.49462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3821.50048828125,
        -3145.371337890625,
        1061.22021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3821.50048828125,
        -3145.37158203125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3901.50048828125,
        -3145.37158203125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3821.50048828125,
        -3167.7685546875,
        1076.49462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3821.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3821.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3901.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.00048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3861.50048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3861.50048828125,
        -3181.7685546875,
        1079.7655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1079.767333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3861.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3861.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3182.2685546875,
        1012.5
      ],
      "bbox_max": [
        -3922.00830078125,
        -3181.77001953125,
        1013.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3184.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3925.0,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3382.87451171875,
      "bbox_min": [
        -3920.030029296875,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1005.28662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3925.0,
        -3184.800048828125,
        1019.71337890625
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3920.030029296875,
        -3184.800048828125,
        1019.71337890625
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.16493375599384308,
        0.9863047003746033
      ],
      "plane_d": -1516.714599609375,
      "bbox_min": [
        -3972.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3125.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8871033191680908,
        -0.3474929630756378,
        0.303803026676178
      ],
      "plane_d": 2109.72216796875,
      "bbox_min": [
        -3972.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3125.0,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9151027798652649,
        -0.2536449432373047,
        -0.31345048546791077
      ],
      "plane_d": 3144.806884765625,
      "bbox_min": [
        -3972.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3125.0,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3182.2685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3925.0,
        -3182.2685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3970.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3970.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3940.000244140625,
      "bbox_min": [
        -3940.00048828125,
        -3224.76806640625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3940.00048828125,
        -3204.7685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3224.76806640625,
        1019.7999877929688
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3940.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3224.76806640625,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9575546383857727,
        -0.28825193643569946
      ],
      "plane_d": -2832.092529296875,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      "bbox_max": [
        -3940.00048828125,
        -3262.422119140625,
        1019.735107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9575546383857727,
        0.28825193643569946
      ],
      "plane_d": -3415.802734375,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      "bbox_max": [
        -3940.00048828125,
        -3262.422119140625,
        1019.735107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      "bbox_max": [
        -3980.00048828125,
        -3262.422119140625,
        1019.735107421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1016.623779296875,
      "bbox_min": [
        -3940.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3224.7685546875,
        1019.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3940.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      "bbox_max": [
        -3898.89990234375,
        -3224.7685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9577639102935791,
        -0.2875555753707886
      ],
      "plane_d": -2833.485595703125,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      "bbox_max": [
        -3898.89990234375,
        -3224.7685546875,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        -0.3239934742450714
      ],
      "plane_d": -3378.144775390625,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      "bbox_max": [
        -3918.912841796875,
        -3224.7685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9448822140693665,
        0.0,
        -0.3274105489253998
      ],
      "plane_d": -3351.147705078125,
      "bbox_min": [
        -3899.97802734375,
        -3264.60009765625,
        1016.623779296875
      ],
      "bbox_max": [
        -3898.89990234375,
        -3263.666015625,
        1019.7349243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3225.60009765625,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        0.3239934742450714
      ],
      "plane_d": -4034.231689453125,
      "bbox_min": [
        -3920.00048828125,
        -3225.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3886.1005859375,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.2237548828125,
      "bbox_min": [
        -3893.900390625,
        -3225.568603515625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3886.1005859375,
        -3224.7685546875,
        1015.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3887.00048828125,
      "bbox_min": [
        -3887.00048828125,
        -3225.568603515625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3887.00048828125,
        -3224.7685546875,
        1015.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        -0.3239934742450714
      ],
      "plane_d": -3378.144775390625,
      "bbox_min": [
        -3918.912841796875,
        -3225.60009765625,
        1012.5
      ],
      "bbox_max": [
        -3917.50048828125,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3244.7685546875,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3225.60009765625,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3905.00048828125,
      "bbox_min": [
        -3920.00048828125,
        -3244.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3905.00048828125,
        -3225.60009765625,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        0.3239934742450714
      ],
      "plane_d": -4034.231689453125,
      "bbox_min": [
        -3920.00048828125,
        -3244.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3917.50048828125,
        -3225.60009765625,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        -0.3239934742450714
      ],
      "plane_d": -3378.144775390625,
      "bbox_min": [
        -3918.912841796875,
        -3244.7685546875,
        1012.5
      ],
      "bbox_max": [
        -3917.50048828125,
        -3225.60009765625,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3917.0,
      "bbox_min": [
        -3917.0,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3244.800048828125,
        1016.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3261.699951171875,
      "bbox_min": [
        -3917.0,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3244.800048828125,
        1016.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3917.0,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3261.699951171875,
        1016.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3263.699951171875,
      "bbox_min": [
        -3917.0,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.89990234375,
        -3261.699951171875,
        1016.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3912.599853515625,
        -3263.699951171875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3901.199951171875,
        -3261.699951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3912.599853515625,
        -3263.699951171875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3901.199951171875,
        -3261.699951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3912.599853515625,
      "bbox_min": [
        -3912.599853515625,
        -3263.699951171875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3901.199951171875,
        -3261.699951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.199951171875,
      "bbox_min": [
        -3901.199951171875,
        -3263.699951171875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3901.199951171875,
        -3261.699951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.89990234375,
        -3263.699951171875,
        1016.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3915.0,
      "bbox_min": [
        -3917.0,
        -3261.699951171875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3244.800048828125,
        1016.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3917.0,
        -3258.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3247.400146484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3917.0,
        -3258.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3247.400146484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3247.400146484375,
      "bbox_min": [
        -3917.0,
        -3258.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3247.400146484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3258.800048828125,
      "bbox_min": [
        -3917.0,
        -3258.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3258.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -995.001220703125,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.36007264256477356,
        -0.9329242706298828
      ],
      "plane_d": 2160.143798828125,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9161573648452759,
        -0.4008188545703888
      ],
      "plane_d": 3470.049072265625,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9161460995674133,
        0.4008445143699646
      ],
      "plane_d": 2659.52978515625,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36191579699516296,
        -0.9322108626365662
      ],
      "plane_d": -238.46160888671875,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0033072875812649727,
        -0.9999945759773254
      ],
      "plane_d": 1015.0679321289062,
      "bbox_min": [
        -4002.39990234375,
        -3301.60595703125,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1025.992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.47210460901260376,
        -0.8815426230430603
      ],
      "plane_d": -649.3966674804688,
      "bbox_min": [
        -4002.39990234375,
        -3301.60595703125,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1025.992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6766357421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9575546383857727,
        -0.28825193643569946
      ],
      "plane_d": -2832.092529296875,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6766357421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.94633549451828,
        0.0,
        -0.3231859505176544
      ],
      "plane_d": -3380.050537109375,
      "bbox_min": [
        -3940.00048828125,
        -3264.61962890625,
        1019.7349243164062
      ],
      "bbox_max": [
        -3919.978271484375,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3940.000244140625,
      "bbox_min": [
        -3940.00048828125,
        -3264.61962890625,
        1019.735107421875
      ],
      "bbox_max": [
        -3940.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1016.6237182617188,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6766357421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9448822140693665,
        0.0,
        -0.3274105489253998
      ],
      "plane_d": -3351.147705078125,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1016.623779296875
      ],
      "bbox_max": [
        -3898.89990234375,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1016.623779296875
      ],
      "bbox_max": [
        -3980.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3980.00048828125,
        -3273.837646484375,
        1011.6766357421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3273.837646484375,
        1011.6766357421875
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3273.793212890625,
        1011.6766967773438
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0001220703125,
        -1.0,
        -4.209329927107319e-05
      ],
      "plane_d": -3265.63330078125,
      "bbox_min": [
        -3898.89990234375,
        -3265.2001953125,
        1011.9979248046875
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9575546383857727,
        -0.28825193643569946
      ],
      "plane_d": -2846.598388671875,
      "bbox_min": [
        -4002.39990234375,
        -3301.60595703125,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1025.992919921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1016.6237182617188,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9448822140693665,
        0.0,
        -0.3274105489253998
      ],
      "plane_d": -3351.147705078125,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1016.623779296875
      ],
      "bbox_max": [
        -3898.89990234375,
        -3273.837646484375,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1016.623779296875
      ],
      "bbox_max": [
        -3980.00048828125,
        -3273.837646484375,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3980.00048828125,
        -3277.473388671875,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3277.473388671875,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3276.800048828125,
      "bbox_min": [
        -3898.89990234375,
        -3277.411865234375,
        1011.6260375976562
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3277.411865234375,
        1016.3624267578125
      ],
      "bbox_max": [
        -3898.89990234375,
        -3276.800048828125,
        1016.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3276.800048828125,
        1011.6260375976562
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0001220703125,
        -1.0,
        -4.209329927107319e-05
      ],
      "plane_d": -3265.63330078125,
      "bbox_min": [
        -3898.89990234375,
        -3265.2001953125,
        1011.6260375976562
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1011.9981079101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3896.89990234375,
        -3265.2001953125,
        1011.6260375976562
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1011.9981079101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3301.60595703125,
        1017.21240234375
      ],
      "bbox_max": [
        -3880.0,
        -3278.989501953125,
        1025.992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.740734998951666e-05,
        2.2878630261402577e-06
      ],
      "plane_d": -3880.0927734375,
      "bbox_min": [
        -3880.00048828125,
        -3301.60595703125,
        1017.21337890625
      ],
      "bbox_max": [
        -3880.0,
        -3278.991943359375,
        1025.992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9135814905166626,
        0.40665584802627563
      ],
      "plane_d": -3423.279052734375,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.010009762831032276,
        0.9999499917030334
      ],
      "plane_d": -1037.9794921875,
      "bbox_min": [
        -4002.39990234375,
        -3299.749267578125,
        1005.0
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1022.2850341796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1005.3519287109375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9575546383857727,
        0.28825193643569946
      ],
      "plane_d": -3415.802734375,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1005.3519287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3940.00048828125,
        -3264.619873046875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.2658081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3896.89990234375,
        -3264.619873046875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.2658081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3880.00048828125,
        -3264.619873046875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.2658081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3940.000244140625,
      "bbox_min": [
        -3940.00048828125,
        -3264.61962890625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3940.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1005.3519287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3898.89990234375,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1005.3518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3278.800048828125,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1005.3518676757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1005.3518676757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.89990234375,
        -3264.60009765625,
        1005.3518676757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3276.800048828125,
      "bbox_min": [
        -3896.89990234375,
        -3276.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3276.800048828125,
        1005.2297973632812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3299.749267578125,
        1005.0
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1022.2850341796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -2.740734998951666e-05,
        2.2878630261402577e-06
      ],
      "plane_d": -3880.0927734375,
      "bbox_min": [
        -4002.39990234375,
        -3299.749267578125,
        1005.0
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1022.2850341796875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9575546383857727,
        -0.28825193643569946
      ],
      "plane_d": -2846.598388671875,
      "bbox_min": [
        -4002.39990234375,
        -3278.991943359375,
        1016.623779296875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3277.47314453125,
        1017.21337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9448822140693665,
        0.0,
        -0.3274105489253998
      ],
      "plane_d": -3351.147705078125,
      "bbox_min": [
        -3980.00048828125,
        -3278.991943359375,
        1016.623779296875
      ],
      "bbox_max": [
        -3898.89990234375,
        -3277.47314453125,
        1017.21337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3278.989501953125,
        1016.623779296875
      ],
      "bbox_max": [
        -3980.00048828125,
        -3277.473388671875,
        1017.21240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -4002.39990234375,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9575546383857727,
        0.28825193643569946
      ],
      "plane_d": -3430.308349609375,
      "bbox_min": [
        -4002.39990234375,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3980.00048828125,
        -3277.571044921875,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9575546383857727,
        -0.28825193643569946
      ],
      "plane_d": -2846.598388671875,
      "bbox_min": [
        -4002.39990234375,
        -3278.812255859375,
        1012.5
      ],
      "bbox_max": [
        -3980.00048828125,
        -3277.571044921875,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3278.800048828125,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2097778320312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2097778320312
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3276.800048828125,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2297973632812
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1016.3623657226562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3894.0,
        -3278.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3882.60009765625,
        -3276.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3894.0,
        -3278.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3882.60009765625,
        -3276.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3882.60009765625,
      "bbox_min": [
        -3894.0,
        -3278.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3882.60009765625,
        -3276.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3894.0,
      "bbox_min": [
        -3894.0,
        -3278.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3894.0,
        -3276.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.2001953125,
        1005.2457885742188
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1015.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3898.89990234375,
        -3275.2001953125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3275.2001953125,
      "bbox_min": [
        -3898.89990234375,
        -3275.2001953125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0001220703125,
        -1.0,
        -4.209329927107319e-05
      ],
      "plane_d": -3265.63330078125,
      "bbox_min": [
        -3898.89990234375,
        -3275.2001953125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3898.89990234375,
        -3275.2001953125,
        1015.0
      ],
      "bbox_max": [
        -3896.89990234375,
        -3273.290771484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9098485708236694,
        -0.4149407148361206
      ],
      "plane_d": -2580.177490234375,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3292.05517578125,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0033072875812649727,
        -0.9999945759773254
      ],
      "plane_d": 1015.0679321289062,
      "bbox_min": [
        -4002.39990234375,
        -3303.743896484375,
        1011.1943359375
      ],
      "bbox_max": [
        -3880.0,
        -3292.05517578125,
        1026.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3303.743896484375,
        1011.1943359375
      ],
      "bbox_max": [
        -3880.0,
        -3292.05517578125,
        1026.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9140501022338867,
        -0.4056013524532318
      ],
      "plane_d": -2603.65185546875,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3296.991943359375,
        1033.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3303.743896484375,
        1010.9752807617188
      ],
      "bbox_max": [
        -3880.0,
        -3296.991943359375,
        1026.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -2.740734998951666e-05,
        2.2878630261402577e-06
      ],
      "plane_d": -3880.0927734375,
      "bbox_min": [
        -3880.0,
        -3303.743896484375,
        1010.9757080078125
      ],
      "bbox_max": [
        -3880.0,
        -3296.991943359375,
        1026.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9140386581420898,
        0.40562722086906433
      ],
      "plane_d": -3423.76611328125,
      "bbox_min": [
        -4022.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3297.08935546875,
        1033.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -2.4546117856516503e-05,
        1.0837805348273832e-05
      ],
      "plane_d": -3880.091552734375,
      "bbox_min": [
        -4002.39990234375,
        -3299.749267578125,
        1005.0
      ],
      "bbox_max": [
        -3880.0,
        -3297.08935546875,
        1011.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3299.749267578125,
        1005.0
      ],
      "bbox_max": [
        -4002.39990234375,
        -3297.08935546875,
        1011.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3769.39990234375,
      "bbox_min": [
        -3769.39990234375,
        -3345.300048828125,
        995.001220703125
      ],
      "bbox_max": [
        -3769.39990234375,
        -3297.10009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1761336326599121,
        -0.9070183038711548,
        0.38248494267463684
      ],
      "plane_d": -2668.737548828125,
      "bbox_min": [
        -4217.6826171875,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3297.10009765625,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17613600194454193,
        -0.90701824426651,
        -0.38248395919799805
      ],
      "plane_d": -1895.344482421875,
      "bbox_min": [
        -4217.6826171875,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3297.10009765625,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1731167435646057,
        -0.9001373648643494,
        -0.39972883462905884
      ],
      "plane_d": -1867.36767578125,
      "bbox_min": [
        -4213.92333984375,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3297.10009765625,
        1033.6243896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.12733320891857147,
        -0.6621010899543762,
        0.7385176420211792
      ],
      "plane_d": -2410.355224609375,
      "bbox_min": [
        -4213.92333984375,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07287567853927612,
        -0.378876656293869,
        -0.9225733280181885
      ],
      "plane_d": -11.266357421875,
      "bbox_min": [
        -4213.92333984375,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.046660855412483215,
        -0.029157865792512894,
        0.9984851479530334
      ],
      "plane_d": -1277.5260009765625,
      "bbox_min": [
        -4207.68505859375,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06760953366756439,
        -0.3610876500606537,
        -0.9300777912139893
      ],
      "plane_d": 34.036712646484375,
      "bbox_min": [
        -4204.921875,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.055681146681308746,
        0.0,
        0.9984485507011414
      ],
      "plane_d": -1217.4293212890625,
      "bbox_min": [
        -4204.921875,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07099748402833939,
        0.3778272569179535,
        -0.9231500029563904
      ],
      "plane_d": 1923.427490234375,
      "bbox_min": [
        -4204.921875,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06549719721078873,
        0.3592994809150696,
        -0.9309210777282715
      ],
      "plane_d": 1892.04931640625,
      "bbox_min": [
        -4195.86767578125,
        -3369.927734375,
        1026.51416015625
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16617104411125183,
        0.911422848701477,
        -0.37642475962638855
      ],
      "plane_d": 2760.78466796875,
      "bbox_min": [
        -4195.86767578125,
        -3369.927734375,
        1026.51416015625
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16272127628326416,
        0.9039468169212341,
        -0.39547672867774963
      ],
      "plane_d": 2769.270263671875,
      "bbox_min": [
        -4027.347412109375,
        -3339.394775390625,
        1026.51416015625
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1204254999756813,
        0.6604939699172974,
        0.7411109805107117
      ],
      "plane_d": 983.1212158203125,
      "bbox_min": [
        -4202.17822265625,
        -3375.859375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1661759316921234,
        0.9114212393760681,
        0.37642672657966614
      ],
      "plane_d": 1999.62646484375,
      "bbox_min": [
        -4195.86767578125,
        -3375.859375,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1627221256494522,
        0.9039356708526611,
        0.3955020606517792
      ],
      "plane_d": 1969.5501708984375,
      "bbox_min": [
        -4192.1611328125,
        -3375.859375,
        995.001220703125
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1011.46142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16272127628326416,
        0.9039468169212341,
        -0.39547672867774963
      ],
      "plane_d": 2769.270263671875,
      "bbox_min": [
        -4192.1611328125,
        -3375.859375,
        1010.9993896484375
      ],
      "bbox_max": [
        -4022.39990234375,
        -3345.09814453125,
        1011.46142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16272127628326416,
        0.9039468169212341,
        -0.39547672867774963
      ],
      "plane_d": 2769.270263671875,
      "bbox_min": [
        -4195.86767578125,
        -3375.859375,
        1010.9993896484375
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.5126953125,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16617104411125183,
        0.911422848701477,
        -0.37642475962638855
      ],
      "plane_d": 2760.78466796875,
      "bbox_min": [
        -4195.86767578125,
        -3375.859375,
        1010.9993896484375
      ],
      "bbox_max": [
        -4027.347412109375,
        -3339.394775390625,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6782577633857727,
        -0.6209645867347717,
        -0.39289847016334534
      ],
      "plane_d": 1186.9688720703125,
      "bbox_min": [
        -4358.3671875,
        -3508.270263671875,
        984.9754028320312
      ],
      "bbox_max": [
        -4192.1611328125,
        -3335.016845703125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795781850814819,
        -0.622826874256134,
        -0.3876340687274933
      ],
      "plane_d": 1180.9044189453125,
      "bbox_min": [
        -4358.3671875,
        -3491.62255859375,
        1010.9993896484375
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        1027.0509033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28048279881477356,
        -0.257059782743454,
        -0.924796998500824
      ],
      "plane_d": 1272.85205078125,
      "bbox_min": [
        -4351.88623046875,
        -3491.62255859375,
        1026.9976806640625
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        1027.0509033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4358.3671875,
        -3508.270263671875,
        984.9754028320312
      ],
      "bbox_max": [
        -4192.1611328125,
        -3335.016845703125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795778274536133,
        -0.6228265166282654,
        0.38763535022735596
      ],
      "plane_d": 397.107421875,
      "bbox_min": [
        -4358.3671875,
        -3491.641357421875,
        994.845703125
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4925941526889801,
        -0.45145776867866516,
        0.7440006732940674
      ],
      "plane_d": -172.863037109375,
      "bbox_min": [
        -4351.88623046875,
        -3491.641357421875,
        994.845703125
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        995.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4925941526889801,
        -0.45145776867866516,
        0.7440006732940674
      ],
      "plane_d": -172.863037109375,
      "bbox_min": [
        -4351.76171875,
        -3508.270263671875,
        984.9754028320312
      ],
      "bbox_max": [
        -4192.1611328125,
        -3341.033203125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27621617913246155,
        -0.25383302569389343,
        -0.9269700050354004
      ],
      "plane_d": 1267.88525390625,
      "bbox_min": [
        -4341.1318359375,
        -3508.270263671875,
        984.9754028320312
      ],
      "bbox_max": [
        -4192.1611328125,
        -3341.033203125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -984.975341796875,
      "bbox_min": [
        -4341.1318359375,
        -3508.270263671875,
        984.9754028320312
      ],
      "bbox_max": [
        -4192.1611328125,
        -3351.016357421875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2788403630256653,
        0.25624457001686096,
        -0.9255197048187256
      ],
      "plane_d": 643.9505615234375,
      "bbox_min": [
        -4336.36865234375,
        -3508.270263671875,
        984.9754028320312
      ],
      "bbox_max": [
        -4192.1611328125,
        -3355.43798828125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2743510603904724,
        0.25287744402885437,
        -0.9277846813201904
      ],
      "plane_d": 653.87060546875,
      "bbox_min": [
        -4320.759765625,
        -3505.42529296875,
        1026.861328125
      ],
      "bbox_max": [
        -4195.8359375,
        -3355.43798828125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6775329113006592,
        0.6245020627975464,
        -0.3885181248188019
      ],
      "plane_d": -339.3046875,
      "bbox_min": [
        -4320.759765625,
        -3505.42529296875,
        1026.861328125
      ],
      "bbox_max": [
        -4195.8359375,
        -3369.927734375,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.488813579082489,
        0.4495965242385864,
        0.747612476348877
      ],
      "plane_d": -1279.89453125,
      "bbox_min": [
        -4331.638671875,
        -3508.270263671875,
        984.9754028320312
      ],
      "bbox_max": [
        -4192.1611328125,
        -3359.828857421875,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4835607707500458,
        0.44571223855018616,
        0.753332257270813
      ],
      "plane_d": -1276.50537109375,
      "bbox_min": [
        -4320.759765625,
        -3505.42529296875,
        984.9754028320312
      ],
      "bbox_max": [
        -4195.80322265625,
        -3359.828857421875,
        995.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6775324940681458,
        0.6245015859603882,
        0.38851937651634216
      ],
      "plane_d": -1124.8887939453125,
      "bbox_min": [
        -4320.759765625,
        -3505.42529296875,
        995.0011596679688
      ],
      "bbox_max": [
        -4195.80322265625,
        -3369.927734375,
        995.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6775329113006592,
        0.6245020627975464,
        -0.3885181248188019
      ],
      "plane_d": -339.3046875,
      "bbox_min": [
        -4320.759765625,
        -3508.270263671875,
        995.0011596679688
      ],
      "bbox_max": [
        -4192.1611328125,
        -3369.978271484375,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6789379119873047,
        0.6266275644302368,
        -0.3825978636741638
      ],
      "plane_d": -344.004150390625,
      "bbox_min": [
        -4320.759765625,
        -3508.270263671875,
        1010.9993896484375
      ],
      "bbox_max": [
        -4192.1611328125,
        -3375.859375,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9049289226531982,
        -0.1581002175807953,
        -0.39510491490364075
      ],
      "plane_d": 3791.90185546875,
      "bbox_min": [
        -4389.13134765625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3488.681640625,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9049283862113953,
        -0.15810012817382812,
        0.3951061964035034
      ],
      "plane_d": 2992.9970703125,
      "bbox_min": [
        -4389.13134765625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3488.681640625,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027932286262512,
        -0.15715810656547546,
        -0.40033215284347534
      ],
      "plane_d": 3791.265625,
      "bbox_min": [
        -4389.13134765625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3491.567138671875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027926325798035,
        -0.1571580022573471,
        0.4003334045410156
      ],
      "plane_d": 2981.791015625,
      "bbox_min": [
        -4389.13134765625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3491.567138671875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6500900983810425,
        -0.11316759139299393,
        0.7513827681541443
      ],
      "plane_d": 1686.3592529296875,
      "bbox_min": [
        -4382.037109375,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3491.567138671875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36769089102745056,
        -0.06400758028030396,
        -0.9277426600456238
      ],
      "plane_d": 2329.45166015625,
      "bbox_min": [
        -4382.037109375,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3491.567138671875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6443429589271545,
        -0.11146288365125656,
        0.756570041179657
      ],
      "plane_d": 1662.260986328125,
      "bbox_min": [
        -4382.037109375,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3496.355224609375,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3627394139766693,
        -0.06256627291440964,
        -0.9297878742218018
      ],
      "plane_d": 2315.13671875,
      "bbox_min": [
        -4382.037109375,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3496.355224609375,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -984.975341796875,
      "bbox_min": [
        -4370.26513671875,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3496.355224609375,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3660587668418884,
        0.06313879787921906,
        -0.928447425365448
      ],
      "plane_d": -406.810302734375,
      "bbox_min": [
        -4365.05126953125,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3498.475830078125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3609141409397125,
        0.061620891094207764,
        -0.9305609464645386
      ],
      "plane_d": -387.73193359375,
      "bbox_min": [
        -4365.05126953125,
        -3664.7685546875,
        1026.864990234375
      ],
      "bbox_max": [
        -4320.759765625,
        -3505.42529296875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9076510071754456,
        0.15496833622455597,
        -0.390069842338562
      ],
      "plane_d": -2977.9111328125,
      "bbox_min": [
        -4347.96533203125,
        -3664.7685546875,
        1026.864990234375
      ],
      "bbox_max": [
        -4320.759765625,
        -3505.42529296875,
        1026.9976806640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6462779641151428,
        0.11113909631967545,
        0.7549654841423035
      ],
      "plane_d": -3154.013671875,
      "bbox_min": [
        -4359.87353515625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4314.3701171875,
        -3500.581787109375,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401939988136292,
        0.10930389910936356,
        0.7603974342346191
      ],
      "plane_d": -3139.564208984375,
      "bbox_min": [
        -4359.87353515625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3505.42529296875,
        995.2698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9076504111289978,
        0.1549682319164276,
        0.3900711238384247
      ],
      "plane_d": -3766.631103515625,
      "bbox_min": [
        -4347.96533203125,
        -3664.7685546875,
        995.0011596679688
      ],
      "bbox_max": [
        -4320.759765625,
        -3505.42529296875,
        995.2698974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9076510071754456,
        0.15496833622455597,
        -0.390069842338562
      ],
      "plane_d": -2977.9111328125,
      "bbox_min": [
        -4347.9072265625,
        -3664.7685546875,
        995.0011596679688
      ],
      "bbox_max": [
        -4314.3701171875,
        -3505.42529296875,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9053404331207275,
        0.15388402342796326,
        0.3958263397216797
      ],
      "plane_d": -3766.287109375,
      "bbox_min": [
        -4341.03076171875,
        -3664.7685546875,
        1010.8619384765625
      ],
      "bbox_max": [
        -4314.3701171875,
        -3508.270263671875,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9076504111289978,
        0.1549682319164276,
        0.3900711238384247
      ],
      "plane_d": -3766.631103515625,
      "bbox_min": [
        -4347.84765625,
        -3664.7685546875,
        995.0011596679688
      ],
      "bbox_max": [
        -4314.3701171875,
        -3505.42529296875,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9053404331207275,
        0.15388402342796326,
        0.3958263397216797
      ],
      "plane_d": -3766.287109375,
      "bbox_min": [
        -4347.84765625,
        -3664.7685546875,
        995.262939453125
      ],
      "bbox_max": [
        -4314.3701171875,
        -3508.270263671875,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3612746000289917,
        0.04250289127230644,
        -0.9314902424812317
      ],
      "plane_d": -458.4078369140625,
      "bbox_min": [
        -4429.13134765625,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3631196618080139,
        -0.04271996393799782,
        -0.9307626485824585
      ],
      "plane_d": 2390.5361328125,
      "bbox_min": [
        -4429.13134765625,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9089117050170898,
        -0.10693079233169556,
        -0.40304532647132874
      ],
      "plane_d": 4004.934814453125,
      "bbox_min": [
        -4429.13134765625,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9089111089706421,
        -0.10693071782588959,
        0.403046578168869
      ],
      "plane_d": 3189.97412109375,
      "bbox_min": [
        -4429.13134765625,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9109771847724915,
        0.10717379301786423,
        -0.3982892334461212
      ],
      "plane_d": -3159.088134765625,
      "bbox_min": [
        -4422.037109375,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9109766483306885,
        0.10717372596263885,
        0.3982905149459839
      ],
      "plane_d": -3964.427490234375,
      "bbox_min": [
        -4422.037109375,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6422120332717896,
        0.07555435597896576,
        0.7627943754196167
      ],
      "plane_d": -3274.40771484375,
      "bbox_min": [
        -4422.037109375,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4347.96533203125,
        -3664.7685546875,
        995.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6465049982070923,
        -0.07605941593647003,
        0.7591087222099304
      ],
      "plane_d": 1798.95458984375,
      "bbox_min": [
        -4422.037109375,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4359.87353515625,
        -3664.7685546875,
        995.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -984.9754028320312,
      "bbox_min": [
        -4410.26513671875,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4359.87353515625,
        -3664.7685546875,
        984.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36138391494750977,
        0.034675855189561844,
        -0.9317721128463745
      ],
      "plane_d": -489.9434814453125,
      "bbox_min": [
        -4469.13134765625,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1034.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3631659150123596,
        -0.03963465988636017,
        -0.9308810830116272
      ],
      "plane_d": 2403.21826171875,
      "bbox_min": [
        -4469.13134765625,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1034.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9100728034973145,
        -0.09437557309865952,
        -0.40356016159057617
      ],
      "plane_d": 4060.878662109375,
      "bbox_min": [
        -4469.13134765625,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9102475643157959,
        -0.09232374280691147,
        0.4036407470703125
      ],
      "plane_d": 3253.7900390625,
      "bbox_min": [
        -4469.13134765625,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9123221039772034,
        0.09254872798919678,
        -0.39887726306915283
      ],
      "plane_d": -3222.95556640625,
      "bbox_min": [
        -4462.037109375,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9121464490890503,
        0.09457611292600632,
        0.3988034725189209
      ],
      "plane_d": -4020.521484375,
      "bbox_min": [
        -4462.037109375,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1011.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.642572820186615,
        0.06786175072193146,
        0.763213574886322
      ],
      "plane_d": -3307.21533203125,
      "bbox_min": [
        -4462.037109375,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4387.96533203125,
        -4004.7685546875,
        996.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6470412611961365,
        -0.06441505998373032,
        0.7597290873527527
      ],
      "plane_d": 1847.3416748046875,
      "bbox_min": [
        -4462.037109375,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4399.87353515625,
        -4004.7685546875,
        996.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.002563937334343791,
        0.9999966621398926
      ],
      "plane_d": -974.7041625976562,
      "bbox_min": [
        -4450.26513671875,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4399.87353515625,
        -4004.7685546875,
        985.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3598810136318207,
        0.09742920100688934,
        -0.9278971552848816
      ],
      "plane_d": -211.4857177734375,
      "bbox_min": [
        -4469.13134765625,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1034.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3617250323295593,
        0.0973547101020813,
        -0.9271877408027649
      ],
      "plane_d": 2995.02880859375,
      "bbox_min": [
        -4469.13134765625,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1034.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9133259654045105,
        0.042525287717580795,
        -0.40500277280807495
      ],
      "plane_d": 4678.525390625,
      "bbox_min": [
        -4469.13134765625,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9133248925209045,
        -0.04252556338906288,
        0.4050053656101227
      ],
      "plane_d": 3485.013671875,
      "bbox_min": [
        -4469.13134765625,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.91544508934021,
        0.042025476694107056,
        -0.4002426564693451
      ],
      "plane_d": -3457.41845703125,
      "bbox_min": [
        -4462.037109375,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154439568519592,
        -0.042025744915008545,
        0.40024518966674805
      ],
      "plane_d": -4636.892578125,
      "bbox_min": [
        -4462.037109375,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1011.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6419899463653564,
        -0.08006472885608673,
        0.7625212073326111
      ],
      "plane_d": -3954.04736328125,
      "bbox_min": [
        -4462.037109375,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4427.96533203125,
        -4394.7685546875,
        996.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6463261246681213,
        -0.07968314737081528,
        0.758889377117157
      ],
      "plane_d": 1777.887451171875,
      "bbox_min": [
        -4462.037109375,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4439.87353515625,
        -4394.7685546875,
        996.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10442563146352768,
        0.9945327639579773
      ],
      "plane_d": -1439.51123046875,
      "bbox_min": [
        -4450.26513671875,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4439.87353515625,
        -4394.7685546875,
        985.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3613501787185669,
        0.03726740926504135,
        -0.931685209274292
      ],
      "plane_d": -490.6060791015625,
      "bbox_min": [
        -4469.13134765625,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1013.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3631994128227234,
        0.037238676100969315,
        -0.9309669733047485
      ],
      "plane_d": 2729.19384765625,
      "bbox_min": [
        -4469.13134765625,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1013.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140328168869019,
        0.016212647780776024,
        -0.40531620383262634
      ],
      "plane_d": 4561.09423828125,
      "bbox_min": [
        -4469.13134765625,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1006.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140316247940063,
        -0.01621275022625923,
        0.4053187668323517
      ],
      "plane_d": 3608.762939453125,
      "bbox_min": [
        -4469.13134765625,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1006.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161369204521179,
        0.01602180488407612,
        -0.4005451202392578
      ],
      "plane_d": -3579.658203125,
      "bbox_min": [
        -4462.037109375,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1006.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161357879638672,
        -0.016021907329559326,
        0.40054768323898315
      ],
      "plane_d": -4520.76904296875,
      "bbox_min": [
        -4462.037109375,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        990.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6437538266181946,
        -0.030584843829274178,
        0.7646210789680481
      ],
      "plane_d": -3736.556396484375,
      "bbox_min": [
        -4462.037109375,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4427.96533203125,
        -4594.7685546875,
        975.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6480850577354431,
        -0.030438559129834175,
        0.7609593868255615
      ],
      "plane_d": 2009.985107421875,
      "bbox_min": [
        -4462.037109375,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4439.87353515625,
        -4594.7685546875,
        975.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.039968281984329224,
        0.9992009997367859
      ],
      "plane_d": -1147.849365234375,
      "bbox_min": [
        -4450.26513671875,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4439.87353515625,
        -4594.7685546875,
        964.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8959311246871948,
        0.1986609250307083,
        0.39729228615760803
      ],
      "plane_d": 4576.75634765625,
      "bbox_min": [
        -4469.13134765625,
        -5039.365234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4381.46240234375,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8991361856460571,
        0.19956056773662567,
        0.3895249664783478
      ],
      "plane_d": 4602.91162109375,
      "bbox_min": [
        -4462.037109375,
        -5039.365234375,
        944.7672119140625
      ],
      "bbox_max": [
        -4410.73193359375,
        -4844.7685546875,
        965.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6455652117729187,
        0.093207947909832,
        0.7579959630966187
      ],
      "plane_d": 2600.639892578125,
      "bbox_min": [
        -4462.037109375,
        -5035.818359375,
        944.7672119140625
      ],
      "bbox_max": [
        -4410.73193359375,
        -4844.7685546875,
        965.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6681129336357117,
        0.09891799092292786,
        0.7374553084373474
      ],
      "plane_d": 2748.2626953125,
      "bbox_min": [
        -4411.8330078125,
        -5035.818359375,
        944.7672119140625
      ],
      "bbox_max": [
        -4410.73193359375,
        -5031.62060546875,
        945.2203369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8756047487258911,
        0.2748812437057495,
        -0.3971858322620392
      ],
      "plane_d": 5634.56787109375,
      "bbox_min": [
        -4469.13134765625,
        -5039.365234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4381.46240234375,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.878730297088623,
        0.2756752073764801,
        -0.3896617293357849
      ],
      "plane_d": 5645.00146484375,
      "bbox_min": [
        -4469.13134765625,
        -5035.818359375,
        976.9976806640625
      ],
      "bbox_max": [
        -4410.9697265625,
        -4844.7685546875,
        997.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31478407979011536,
        0.18166735768318176,
        -0.9316157102584839
      ],
      "plane_d": 3213.533203125,
      "bbox_min": [
        -4462.037109375,
        -5035.818359375,
        976.9976806640625
      ],
      "bbox_max": [
        -4410.9697265625,
        -4844.7685546875,
        997.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35644805431365967,
        0.19536425173282623,
        -0.9136616587638855
      ],
      "plane_d": 3447.8974609375,
      "bbox_min": [
        -4462.037109375,
        -4846.80712890625,
        996.8483276367188
      ],
      "bbox_max": [
        -4461.302734375,
        -4844.7685546875,
        997.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31478407979011536,
        0.18166735768318176,
        -0.9316157102584839
      ],
      "plane_d": 3213.533203125,
      "bbox_min": [
        -4462.037109375,
        -5035.818359375,
        934.9754028320312
      ],
      "bbox_max": [
        -4381.46240234375,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4048488438129425,
        -0.008032616227865219,
        -0.9143483638763428
      ],
      "plane_d": -920.8276977539062,
      "bbox_min": [
        -4445.05126953125,
        -5027.3251953125,
        983.6243896484375
      ],
      "bbox_max": [
        -4396.25927734375,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36158135533332825,
        0.010522343218326569,
        -0.9322812557220459
      ],
      "plane_d": -620.6091918945312,
      "bbox_min": [
        -4445.05126953125,
        -4855.658203125,
        1001.9581298828125
      ],
      "bbox_max": [
        -4441.07177734375,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6455652117729187,
        0.093207947909832,
        0.7579959630966187
      ],
      "plane_d": 2600.639892578125,
      "bbox_min": [
        -4462.037109375,
        -5035.68115234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4381.46240234375,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053711019456386566,
        -0.09303145855665207,
        0.9942134022712708
      ],
      "plane_d": -1161.136962890625,
      "bbox_min": [
        -4450.26513671875,
        -5035.68115234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4400.10400390625,
        -4844.7685546875,
        954.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6681129336357117,
        0.09891799092292786,
        0.7374553084373474
      ],
      "plane_d": 2748.2626953125,
      "bbox_min": [
        -4450.26513671875,
        -5035.68115234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4400.77490234375,
        -4844.7685546875,
        954.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053711019456386566,
        -0.09303145855665207,
        0.9942134022712708
      ],
      "plane_d": -1161.136962890625,
      "bbox_min": [
        -4450.26513671875,
        -5029.544921875,
        934.9754028320312
      ],
      "bbox_max": [
        -4381.46240234375,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36158135533332825,
        0.010522343218326569,
        -0.9322812557220459
      ],
      "plane_d": -620.6091918945312,
      "bbox_min": [
        -4443.82861328125,
        -5027.3251953125,
        976.9976806640625
      ],
      "bbox_max": [
        -4381.46240234375,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4048488438129425,
        -0.008032616227865219,
        -0.9143483638763428
      ],
      "plane_d": -920.8276977539062,
      "bbox_min": [
        -4441.07177734375,
        -5027.3251953125,
        976.9976806640625
      ],
      "bbox_max": [
        -4381.46240234375,
        -4855.658203125,
        1001.9581298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7021172046661377,
        0.5889592170715332,
        0.4001980721950531
      ],
      "plane_d": 5684.7216796875,
      "bbox_min": [
        -4417.11328125,
        -5181.8818359375,
        894.9754028320312
      ],
      "bbox_max": [
        -4262.72607421875,
        -5027.3251953125,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7057133913040161,
        0.5948261618614197,
        0.38490328192710876
      ],
      "plane_d": 5744.5830078125,
      "bbox_min": [
        -4410.9697265625,
        -5181.8818359375,
        904.52001953125
      ],
      "bbox_max": [
        -4270.9365234375,
        -5035.818359375,
        945.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5815938115119934,
        0.3744358718395233,
        0.7221817374229431
      ],
      "plane_d": 3768.52099609375,
      "bbox_min": [
        -4410.9697265625,
        -5175.73828125,
        904.52001953125
      ],
      "bbox_max": [
        -4270.9365234375,
        -5035.818359375,
        945.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5898206233978271,
        0.70142662525177,
        -0.40014028549194336
      ],
      "plane_d": 6524.583984375,
      "bbox_min": [
        -4417.11328125,
        -5181.8818359375,
        894.9754028320312
      ],
      "bbox_max": [
        -4262.72607421875,
        -5027.3251953125,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5956243276596069,
        0.7049746513366699,
        -0.3850228190422058
      ],
      "plane_d": 6553.5712890625,
      "bbox_min": [
        -4417.11328125,
        -5175.73828125,
        936.9976806640625
      ],
      "bbox_max": [
        -4271.21875,
        -5035.61279296875,
        977.1580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09683236479759216,
        0.36178645491600037,
        -0.9272184371948242
      ],
      "plane_d": 3154.905517578125,
      "bbox_min": [
        -4410.9697265625,
        -5175.73828125,
        936.9976806640625
      ],
      "bbox_max": [
        -4271.21875,
        -5035.61279296875,
        977.1580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15714304149150848,
        0.4238094091415405,
        -0.8920155763626099
      ],
      "plane_d": 3698.877685546875,
      "bbox_min": [
        -4410.9697265625,
        -5038.619140625,
        976.2511596679688
      ],
      "bbox_max": [
        -4407.65380859375,
        -5035.61279296875,
        977.1580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5815938115119934,
        0.3744358718395233,
        0.7221817374229431
      ],
      "plane_d": 3768.52099609375,
      "bbox_min": [
        -4410.9697265625,
        -5175.73828125,
        894.9754028320312
      ],
      "bbox_max": [
        -4262.72607421875,
        -5027.3251953125,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09683236479759216,
        0.36178645491600037,
        -0.9272184371948242
      ],
      "plane_d": 3154.905517578125,
      "bbox_min": [
        -4410.61376953125,
        -5175.73828125,
        936.9976806640625
      ],
      "bbox_max": [
        -4262.72607421875,
        -5027.3251953125,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15714304149150848,
        0.4238094091415405,
        -0.8920155763626099
      ],
      "plane_d": 3698.877685546875,
      "bbox_min": [
        -4410.61376953125,
        -5161.02783203125,
        943.6243896484375
      ],
      "bbox_max": [
        -4262.72607421875,
        -5027.3251953125,
        983.6243896484375
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: platform",
      "entity_class": "CSlidingDoor",
      "piece_name": "platform",
      "offset": 26936,
      "centroid": [
        -3900.625,
        -3295.2000732421875,
        1004.4502563476562
      ],
      "bbox_min": [
        -3905.25,
        -3300.60009765625,
        1003.8999633789062
      ],
      "bbox_max": [
        -3896.0,
        -3289.800048828125,
        1005.0005493164062
      ],
      "dimensions_source": {
        "span_x": 9.25,
        "span_y": 10.800048828125,
        "height_z": 1.1005859375,
        "door_width": 10.800048828125,
        "door_depth": 9.25,
        "leaf_depth": 9.21,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3905.25,
          -3300.60009765625,
          1003.8999633789062
        ],
        [
          -3905.25,
          -3289.800048828125,
          1005.0005493164062
        ],
        [
          -3905.25,
          -3300.60009765625,
          1005.0005493164062
        ],
        [
          -3905.25,
          -3289.800048828125,
          1003.8999633789062
        ],
        [
          -3896.0,
          -3300.60009765625,
          1003.8999633789062
        ],
        [
          -3896.0,
          -3289.800048828125,
          1005.0005493164062
        ],
        [
          -3896.0,
          -3300.60009765625,
          1005.0005493164062
        ],
        [
          -3896.0,
          -3289.800048828125,
          1003.8999633789062
        ]
      ],
      "plane_distance": -3905.25,
      "authentic_texture": "airgums"
    }
  ],
  "tutorial_messages": []
}